import logo from './logo.png';
import axios from 'axios';
import useLocalStorageState from 'use-local-storage-state';
import { FaPowerOff } from "react-icons/fa6";
const Navbar = () => {  
    const [token, setToken] = useLocalStorageState('token', '');
    const logOut=()=>{ 
        let endpoint = process.env.REACT_APP_PHP_URL+'logout';
        const BEARER_TOKEN = token;
        setToken(null);
        axios(endpoint, {
          method: "POST",
          headers: {
            'Authorization': `Bearer ${BEARER_TOKEN}`
        },
          withCredentials: true
          }).then((response ) => {
            localStorage.clear();
            window.location.href = '/';
          }) .catch(error => {
            localStorage.clear();
            window.location.href = '/';
          });
        }
    return (<nav className="navbar navbar-light">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="" width="50%"/>
          </a>
          <a className="btn btn-primary logoff_btn" onClick={logOut}>
          <FaPowerOff className="powerOff" />
          </a>
        </div>
      </nav>);
}
export default Navbar;